module.exports = __webpack_public_path__ + "img/new_banner_hk.67b84640.jpg";